// 导出配置的路由器
export default [{
  path: '/memberCenter',
  component: () => import('@/layout/index'),
  redirect: 'memberCenter/carrierManagement',
  meta: {
    title: '用户中心',
    icon: 'icon-huiyuan2',
    perms: ['bee:member']
  },
  children: [
    /*  {
       path: 'carrierManagement',
       component: () => import('@/module/memberCenter/page/operator/manage.vue'),
       meta: {
         title: '运营商管理',
         icon: 'icon-yunyingshang1',
         perms: ['bee:member:operator']
       }
     }, */
    {
      path: 'groupManagement',
      component: () => import('@/module/memberCenter/page/group/manage.vue'),
      meta: {
        title: '集团管理',
        icon: 'icon-jituan1',
        perms: ['bee:member:group']
      }
    },
    /* {
      path: 'memberManagement',
      component: () => import('@/module/memberCenter/page/customer/manage.vue'),
      meta: {
        title: '用户管理',
        icon: 'icon-huiyuan',
        perms: ['bee:member:customer']
      }
    },
    {
      path: 'walletManagement',
      component: () => import('@/module/memberCenter/page/wallet/manage.vue'),
      meta: {
        title: '钱包管理',
        icon: 'icon-jifen2',
        perms: ['bee:member:wallet']
      }
    },
    {
      path: 'rechargeCarmichaelManagement',
      component: () => import('@/module/memberCenter/page/rechargeCarmichael/manage.vue'),
      meta: {
        title: '充值卡密管理',
        icon: 'icon-jifen2',
        perms: ['bee:member:rechargeCarmichael']
      }
    } */

  ]
}]



// WEBPACK FOOTER //
// ./src/module/memberCenter/router/index.js